// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3Dk-L","content":"classes_content__sG97w","title":"classes_title__IiHNZ","slash":"classes_slash__1czAi","divider":"classes_divider__37J3u"};